export default {
    manage_temperature: "Temperatura",
    manage_temperatures_label: "Unidad",
    manage_temperatures_zone_label: "Zona",
    manage_temperatures_zone_name: "Nombre",
    manage_temperatures_zone_high: "Temperatura Máxima (°F)",
    manage_temperatures_zone_low: "Temperatura Mínima (°F)",
    manage_temperatures_search_by_vehicle: "Buscar por Unidad"
}